require('angular');
require('angular-animate');
require('angular-ui-router');
require('angular-scroll');
require('ngmap');
require('angular-messages');
require('./app/modules/angular-phone-filter.dfx');
require('./app/modules/dfx.check-connection');
